import React, { AllHTMLAttributes, ReactNode } from "react";
import styles from "./chip-icon.module.css";
import { Optional } from "../../types";

export type ChipIconProps = {
  children: ReactNode;
  as?: Optional<string>;
} & AllHTMLAttributes<HTMLDivElement>;

export function ChipIcon({ children, as = "div", ...props }: ChipIconProps) {
  return React.createElement(
    as ?? "div",
    {
      className: styles.Container,
      ...props,
    },
    children
  );
}
